import * as yup from 'yup';
import { schemaDefault } from '../../SchemaDefault';

const commonPlaybackSchema = yup
  .object()
  .shape({
    time: yup.number().min(0).required(),
  })
  .strict();

export default {
  play: schemaDefault.concat(commonPlaybackSchema).strict(),
  pause: schemaDefault.concat(commonPlaybackSchema).strict(),
};
